import React, { useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { empdGlobeWhite } from "../../Assets/Images";
import ContentWrapper from "../../Components/ContentWrapper";
import { NavLink } from "react-router";
import { EmpdContext } from "../..//Context";

export const DASHBOARD_ROUTES = [
  {
    name: "Provider Dashboard",
    path: "/provider/dashboard",
  },
  {
    name: "Documents",
    path: "/provider/documents",
  },
  {
    name: "Resources / Educational",
    path: "/provider/resources",
  },
  {
    name: "Log out",
    path: "/provider//logout",
  },
];

const useStyles = createUseStyles({
  root: {
    width: "100%",
    backgroundColor: "#152E54",
  },
  rootInner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logo: {
    width: 350,
    padding: "20px 0px",
  },
  navLinksWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignSelf: "end",
  },
  navLinks: {
    marginRight: "20px",
  },
  link: {
    textDecoration: "none",
    marginLeft: "35px",
    padding: "35px 0px",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "14px",
    display: "inline-block",
  },
  activeLink: {
    fontWeight: "bold",
    borderBottom: "5px solid #f6bb60",
    color: "#f6bb60",
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const DashboardNavigationBar = () => {
  const classes = useStyles();
  const context = useMyContext();
  const { user, fetchProfile} = context;

  useEffect(() => {
  	fetchProfile('provider/dashboard')
  }, [])

  return (
    <div className={classes.root}>
      <ContentWrapper>
        <div className={classes.rootInner}>
          <img
            src={empdGlobeWhite}
            alt="EMPD globe logo"
            className={classes.logo}
          />
          <div className={classes.navLinksWrapper}>
            <div className={classes.navLinks}>
              {DASHBOARD_ROUTES.map((link) => (
               	<NavLink
					key={link.name}
        		    to={link.path}
                	className={({ isActive }) =>
		            	isActive
        		        ? `${classes.link} ${classes.activeLink}`
                		: classes.link
		            }
        		>
                	{link.name}
		        </NavLink>
			  ))}
            </div>
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};

export default DashboardNavigationBar;
